export default __webpack_public_path__ + "static/1-2050b07e650a290ac39d14ebf8adc6fc.jpg";